import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import MainRoutes from './MainRoutes';
import { AuthProvider } from './context/AuthContext';
import { AuthSecurityProvider } from "./context/AuthSecurityContext";
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { SocketProvider } from './context/SocketContext';
import { CompanyProvider } from "./context/CompanyContext";
import { SidebarProvider } from "./context/SidebarContext";
import { PermissionProvider } from './context/PermissionContext';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import theme from './theme/theme';
import queryClient from './lib/queryClient';
import AppUpdate from './components/AppUpdate/AppUpdate';

import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <QueryClientProvider client={queryClient}>
                <AuthSecurityProvider>
                    <AuthProvider>
                        <PermissionProvider>
                            <BrowserRouter>
                                <SocketProvider>
                                    <CompanyProvider>
                                        <SidebarProvider>
                                            <MainRoutes />
                                            <AppUpdate />
                                        </SidebarProvider>
                                        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                                    </CompanyProvider>
                                </SocketProvider>
                            </BrowserRouter>
                        </PermissionProvider>
                    </AuthProvider>
                </AuthSecurityProvider>
            </QueryClientProvider>
        </ThemeProvider>
    </React.StrictMode>
);
